<template>
  <div class="chatMessages" >
    <el-divider content-position="left">微信聊天记录</el-divider>
    <el-row class="mb-10" :gutter="10">
      <el-col :span="24">
        <el-select clearable v-model="searchArr.keywords" placeholder="选择关键词搜素" size="mini" @change="handleChatNameChange">
          <el-option label="开票" value="开票"></el-option>
          <el-option label="待办" value="待办"></el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-table :data="pageData" size="mini" border style="width: 100%">
      <el-table-column label='群名' prop='chat_name'>
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.chat_name" placement="top">
            <span class="hide-style">{{ scope.row.chat_name }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label='发送人' prop='user_nickname'></el-table-column>
      <el-table-column label='内容' prop='content'>
        <template slot-scope="scope">
          <el-popover placement="top-start" width="400" trigger="hover">
            <div slot v-html="highlight(scope.row.content)"></div>
            <span class="hide-style" slot="reference">{{ scope.row.content }}</span>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label='发送时间' prop='created_at'></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="primary" icon="el-icon-chat-dot-square" size="mini" circle @click="showMessages(scope.row.chat_id, scope.row.chat_name)"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      class="mt-10 text-r"
      layout="total, prev, pager, next, jumper"
      :hide-on-single-page="false"
      :current-page="pageOption.currentPage"
      :page-size="pageOption.pageSize"
      :total="pageOption.total"
      @current-change="handleCurrentChange">
    </el-pagination>
    <el-drawer title="聊天记录" :visible.sync="chatDrawer" direction="rtl" size="50%" :before-close="handleChatBeforeClose">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <chat :chatId="chatId" :chatName="chatName"></chat>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Chat from 'common/Chat'
export default {
  name: 'ChatMessages',
  components: {
    Chat
  },
  data () {
    return {

      pageData: [],
      pageOption: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      searchArr: {
        keywords: ''
      },
      chatName: '',
      chatDrawer: false,
      chatId: ''
    }
  },
  computed: {
    searchStr: function () {
      let str = ''
      for (let key in this.searchArr) {
        str += '&' + key + '=' + this.searchArr[key]
      }

      return str
    },    
    collapse () {
      return this.$store.state.collapse
    }
  },
  methods: {
    getPageData () {
      this.$axios.get('/api/admin/wechat_user_messages?page=' + this.pageOption.currentPage + this.searchStr)
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.pageData = data.data.pageData.data
            this.pageOption.total = data.data.pageData.total
            this.pageData.currentPage = data.data.pageData.current_page
          }
        })
    },
    handleCurrentChange (val) {
      this.pageOption.currentPage = val
      this.getPageData()
    },
    handleChatNameChange (val) {
      this.pageOption.currentPage = 1
      this.getPageData()
    },
    highlight (str) {
      str = '<div>' + str + '</div>'

      if (this.searchArr.keywords) {
        str = str.replace(this.searchArr.keywords, '<span style="color:red">' + this.searchArr.keywords + '</span>')
      }

      return str
    },
    showMessages (chatId, chatName) {
      this.chatDrawer = true
      setTimeout(() => {
        this.chatId = chatId
        this.chatName = chatName
      })
    },
    handleChatBeforeClose (done) {
      this.chatId = ''
      this.chatName = ''
      done()
    }
  },
  mounted () {
    this.getPageData()
  }
}
</script>

<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  .chatMessages
    marginLeft()
    .mb-10
      margin-bottom: .2rem
    .mt-10
      margin-top: .2rem
    .text-c
      text-align: center
    .text-r
      text-align: right
    .hide-style
      display: inherit
      overflow: hidden
      text-overflow: ellipsis
      white-space: nowrap
  .messages-list
    min-height: calc(100vh - 210px)
    height: 6rem
    overflow-y: auto
    .messages-con
      padding: .4rem
      .message
        padding: .2rem
      .image_con
        padding: .2rem
    .infinite-item-content
      display: inline-block
      margin-top: .2rem
      padding: 0 .36rem 0 .36rem
      line-height: .9rem
      background-color: #eef0f5
    .popper__arrow
      position: absolute
      top: .04rem
      left: .36rem
      display: block
      margin-right: .06rem
      border-color: transparent
      border-style: solid
      border-width: .18rem
      border-top-width: 0
      border-bottom-color: #eef0f5
      filter: drop-shadow(0 2px 12px rgba(0,0,0,.03))
</style>



// WEBPACK FOOTER //
// src/pages/conversation/ChatMessages.vue